export default "__VITE_ASSET__0843359e__"